import series from '@/application/lib/series'
import stock from '@/application/mixins/stock'
import _ from 'lodash'

export default {
    mixins: [stock],
    data() {
        return {
            view: 'invoiceForm',
            app: 'invoices',
            loading: true,
            loadingSerial: false,
            serie: null,
            fields: {
                price_delivered: 0,
                price_returned: 0,
                price_payed: 0,
                observations: '',
                date: this.$moment(),
                serie: 0,
                serie_r: null,
                client: null,
                client_address: '',
                client_country: '',
                client_cp: '',
                client_location: '',
                client_name: '',
                client_legal_name: '',
                client_state: '',
                iva: 0,
                iva_percent: 0,
                discount: 0,
                discount_percent: 0,
                surcharge: 0,
                surcharge_percent: 0,
                concepts: [
                    {
                        article: null,
                        discount: 0,
                        discount_value: 0,
                        expiration_date: this.$moment().format('YYYY-MM-DD'),
                        lot: null,
                        name: '',
                        price: 0,
                        quantity: 1,
                        iva: 0,
                        iva_value: 0,
                        surcharge: 0,
                        surcharge_value: 0,
                    },
                ],
            },
            fields_b: {},
        }
    },
    computed: {
        id() {
            return parseInt(this.$route.params.id, 10) || 0
        },
        config() {
            return this.$gestios.$cache.config
        },
    },
    methods: {
        // Load events
        events(enable = true) {
            if (enable) {
                this.$hub.$on('listInvoice', () => {
                    this.$router.push({ name: 'invoices' })
                })
            } else {
                this.$hub.$off('listInvoice')
            }
        },
        // Load config
        async loadConfig() {
            return await this.$gestios.config.list(['name', 'address', 'address2', 'CIF', 'mail', 'phone', 'logo'])
        },
        // Load invoice
        async load() {
            try {
                if (this.id > 0) {
                    let invoice = await this.$gestios.items('invoices').get(this.id)

                    if (invoice.ok) {
                        invoice = invoice.data
                        this.fields.client = {
                            key: invoice.client._EntityId.toString(),
                            label: invoice.client.legal_name,
                            data: invoice.client,
                        }

                        this.fields.client_address = invoice.client_address
                        this.fields.client_cp = invoice.client_cp
                        this.fields.client_location = invoice.client_location
                        this.fields.client_name = invoice.client_name
                        this.fields.client_legal_name = invoice.client_legal_name
                        this.fields.client_country = invoice.client_country
                        this.fields.client_state = invoice.client_state
                        this.fields.date = invoice.date
                        this.fields.observations = invoice.observations
                        this.fields.price_payed = invoice.price_payed
                        this.fields.price_delivered = invoice.price_delivered
                        this.fields.price_returned = invoice.price_returned

                        // CALCULATION
                        this.fields.iva = invoice.iva
                        this.fields.iva_percent = invoice.iva_percent
                        this.fields.surcharge = invoice.surcharge
                        this.fields.surcharge_percent = invoice.surcharge_percent
                        this.fields.discount = invoice.discount
                        this.fields.discount_percent = invoice.discount_percent

                        // SERIE
                        this.fields.serie = invoice.serie
                        this.fields.serie_r = invoice.serie_r

                        this.fields.concepts = []

                        for (let i = 0; i < invoice.concepts.length; i += 1) {
                            const concept = invoice.concepts[i]

                            this.fields.concepts.push({
                                article: {
                                    key: concept.article,
                                    label: concept.name,
                                    data: concept,
                                },
                                lot: {
                                    key: concept.lot,
                                    label: 'Lote ya asignado',
                                },
                                expiration_date: concept.expiration_date,
                                price: concept.price,
                                quantity: concept.quantity,
                                discount: concept.discount,
                                iva: concept.iva,
                                name: concept.name,
                            })
                        }

                        this.fields_b = _.cloneDeep(this.fields)
                    }
                }
            } catch (error) {
                console.error(error)
                return false
            }
        },
        // Save invoice
        async save() {
            try {
                this.loading = true

                const params = {
                    // GENERAL
                    observations: this.fields.observations,
                    date: this.fields.date,

                    // SERIE
                    serie: this.fields.serie,
                    serie_r: this.fields.serie_r._EntityId || null,

                    // CALCULATION
                    subtotal: this.totalCalculations.subtotal,
                    total: this.totalCalculations.total,
                    iva: this.totalCalculations.iva.value,
                    iva_percent: this.totalCalculations.iva.percent,
                    surcharge: this.totalCalculations.surcharge.value,
                    surcharge_percent: this.totalCalculations.surcharge.percent,
                    discount: this.totalCalculations.discount.value,
                    discount_percent: this.totalCalculations.discount.percent,

                    // PAY
                    price_delivered: this.fields.price_delivered,
                    price_returned: this.fields.price_returned,
                    price_payed: this.fields.price_payed,

                    // CLIENT
                    client: this.fields.client.key,
                    client_name: this.fields.client_name,
                    client_legal_name: this.fields.client_legal_name,
                    client_address: this.fields.client_address,
                    client_country: this.fields.client_country,
                    client_cp: this.fields.client_cp,
                    client_location: this.fields.client_location,
                    client_state: this.fields.client_state,
                    concepts: [],
                }

                Object.keys(this.fields.concepts).forEach((key) => {
                    const concept = this.fields.concepts[key]

                    if (concept.article) {
                        params.concepts.push({
                            expiration_date: concept.expiration_date,
                            lot: concept.lot.key,
                            name: concept.name,
                            price: concept.price,
                            quantity: concept.quantity,
                            article: concept.article.key,
                            // TAXES
                            iva: this.conceptCalculation[key].iva.percent,
                            iva_value: this.conceptCalculation[key].iva.value,
                            surcharge: this.conceptCalculation[key].surcharge.percent,
                            surcharge_value: this.conceptCalculation[key].surcharge.value,
                            discount: this.conceptCalculation[key].discount.percent,
                            discount_value: this.conceptCalculation[key].discount.value,
                        })
                    }
                })

                const newConcepts = params.concepts
                params.concepts = JSON.stringify(params.concepts)

                let data
                if (this.id > 0) {
                    data = await this.$gestios.items('invoices').edit({ id: this.id, params })
                } else {
                    data = await this.$gestios.items('invoices').add({ params, view: this.view })
                }

                if (data.ok) {
                    if (this.id > 0) {
                        this.calibrateStock(newConcepts, this.fields_b.concepts)
                    } else {
                        this.calibrateStock(newConcepts)
                    }

                    if (!this.id && this.nextSerie && this.nextSerie === params.serie) {
                        await series.editSerialValue(this.fields.serie_r._EntityId)
                    }
                    this.$router.push({ name: 'invoices' })
                }

                this.loading = false

                return true
            } catch (error) {
                console.error(error)
                this.loading = false
                return false
            }
        },
    },
}
